module.exports = __webpack_public_path__ + "static/canadalearningcode-logo-6bf6817edf4e42be5583161c251ad0b5.png";